<template>
  <div class="terms">
    <header class="header">
      <div class="container">
        <div class="header-content">
          <div class="logo-container">
            <img src="@/assets/logo.png" alt="Forms Pro Logo" class="logo-img" />
            <h1 class="logo">Forms Pro for Google Forms</h1>
          </div>
          <nav class="nav">
            <router-link to="/" class="nav-link">Home</router-link>
            <a href="/privacy" class="nav-link">Privacy</a>
            <a href="/terms" class="nav-link">Terms</a>
            <router-link to="/subscription" class="nav-link">Subscription</router-link>
          </nav>
        </div>
      </div>
    </header>

    <main class="main">
      <div class="container">
        <div class="content-wrapper">
          <h1 class="page-title">Terms of Use and End User License Agreement</h1>

          <section class="section intro">
            <h2>I. INTRODUCTION</h2>
            <p>
              These Terms of Use and End User License Agreement (collectively, the "Agreement") together with all the documents referred to in it constitute a legally binding agreement made between you as a natural person ("you", "your" or "user") and Yikens Technology HK Limited ("we," "us" or "our"), concerning your access to and use of "Forms Pro for Google Forms" software application for mobile devices (the "App").
            </p>
            <p>
              All the documents that relate to the App are hereby expressly incorporated herein by reference.
            </p>
            <p>
              Please read this Agreement carefully before you download, install or use the App.
            </p>
            <p>
              It is important that you read and understand this Agreement as by downloading, installing or using the App you indicate that you have read, understood, agreed and accepted the Agreement which takes effect on the date on which you download, install or use the App. By using the App you agree to abide by this Agreement.
            </p>
            <p>
              If you do not agree with (do not accept) this Agreement, or if you do not agree at least with one of the provisions of this Agreement, you are not authorized to, and you may not access, download, install or use the App and you must promptly discontinue downloading, installing the App and remove (delete) the App from any mobile device in your possession or under your control.
            </p>
          </section>

          <section class="section">
            <h2>II. CHANGES TO THIS AGREEMENT</h2>
            <p>
              We reserve the right, at our sole discretion, to make changes or modifications to this Agreement at any time and for any reason. We will keep you informed about any changes by updating this Agreement and you waive any right to receive specific notice of each such change. It is your responsibility to periodically review this Agreement to stay informed of updates. You will be subject to, and will be deemed to be aware of and to have accepted, the changes in any revised Agreement by your continued use of the App after the date such revised Agreement is posted.
            </p>
          </section>

          <section class="section">
            <h2>III. RESTRICTIONS ON WHO CAN USE THE APP</h2>
            <p>
              In order to download, install, access or use the App, you must (a) be eighteen (18) years of age or older.
            </p>
            <p>
              All users who are minors in the jurisdiction in which they reside (generally under the age of 18) must have the permission of, and be directly supervised by, their parent or guardian to use the App, so if you are between the ages of thirteen (13) and seventeen (17) years and you wish to use download, install, access or use the App, before doing so you must: (a) assure and confirm (if needed) that your parent or guardian have read and agree (get your parent or guardian's consent) to this Agreement prior to you using the App; (b) have the power to enter a binding contract with us and not be barred from doing so under any applicable laws.
            </p>
            <p>
              Parents and guardians must directly supervise any use of the App by minors.
            </p>
            <p>
              Any person under the age of thirteen (13) years is not permitted to download, install, access or use the App.
            </p>
            <p>
              You affirm that you are either more than eighteen 18 years of age, or an emancipated minor, or possess legal parental or guardian consent, and are fully able and competent to enter into the terms, conditions, obligations, affirmations, representations, and warranties set forth in this Agreement, and to abide by and comply with this Agreement.
            </p>
          </section>

          <section class="section">
            <h2>IV. GENERAL TERMS</h2>
            <p>
              The App is a productivity program designed to enhance your device experience. The App allows to manage your Google forms located on your Google drive on your iOS device. You can create new forms or make changes to the forms that you have already created in your Google Drive. You can also view all the responses to your forms using gaphs and charts.
            </p>
            <p>
              The App is intended only for your personal non-commercial use. You shall use the App only for the purposes, mentioned above.
            </p>
          </section>

          <section class="section">
            <h2>V. PRIVACY POLICY</h2>
            <p>
              Your privacy is very important to us. Accordingly, we have developed the Privacy Policy in order for you to understand how we process, use and store information including personal data. Access to the App and use of the Services is subject to the Privacy Policy. By accessing the App and by continuing to use the Services, you are deemed to have accepted the Privacy Policy, and in particular, you are deemed to have acknowledged the ways we process your information as well as appropriate legal grounds for processing described in the Privacy Policy. We reserve the right to amend the Privacy Policy from time to time. If you disagree with any part of the Privacy Policy, you must immediately stop using the App and Services. Please read our Privacy Policy carefully.
            </p>
          </section>

          <section class="section">
            <h2>VI. END USER LICENSE AGREEMENT</h2>
            <p>
              By using the App, you undertake to respect our intellectual rights (intellectual rights related to the App's source code, UI/UX design, content material, copyright and trademarks, hereinafter referred to as the "Intellectual Property Rights") as well as those owned by third parties.
            </p>
            <p>
              As long as you keep using the App, we grant you a limited, non-exclusive, non-transferable non-sublicensable, non-assignable and revocable license to access and use the App pursuant to this Agreement on any Apple-branded products that you own or control except that the App may be accessed and used by other accounts associated with you via Family Sharing or volume purchasing (the "License").
            </p>
            <p>
              The source code, design and content, including information, photographs, illustrations, artwork and other graphic materials, sounds, music or video (hereinafter – the "works") as well as names, logos and trademarks (hereinafter – "means of individualization") within the App are protected by copyright laws and other relevant laws and/or international treaties, and belong to us and/or our partners and/or contracted third parties, as the case may be.
            </p>
            <p>
              In the event of any third party claim that your possession and use of the App infringes that third party's intellectual property rights, Apple will not be responsible for the investigation, defense, settlement and discharge of any such intellectual property infringement claim.
            </p>
            <p>
              These works and means of individualization may not be copied, reproduced, retransmitted, distributed, disseminated, sold, published, broadcasted or circulated whether in whole or in part, unless expressly permitted by us and/or our partners and/or contracted third parties, as the case may be.
            </p>
            <p>
              All rights, title and interest in and to the App and its content, works and means of individualization as well as its functionalities (1) are the exclusive property of Yikens Technology HK Limited and/or our partners and/or contracted third parties, (2) are protected by the applicable international and national legal provisions, and (3) are under no circumstances transferred (assigned) to you in full or in part within the context of the license herewithin.
            </p>
            <p>
              We will not hesitate to take legal action against any unauthorized use of our trademarks, names or symbols to protect and restore our rights. All rights not expressly granted herein are reserved. Other product and company names mentioned herein may also be the trademarks of their respective owners.
            </p>
          </section>

          <section class="section">
            <h2>VII. PROHIBITED BEHAVIOUR</h2>
            <p>
              You agree not to use the App in any way that:
            </p>
            <ul>
              <li>is unlawful, illegal or unauthorized;</li>
              <li>is defamatory of any other person;</li>
              <li>is obscene or offensive;</li>
              <li>infringes any copyright, database right or trademark of any other person;</li>
              <li>advocates, promotes or assists any unlawful act such as (by way of example only) copyright infringement or computer misuse.</li>
            </ul>
            <p>
              You shall not make the App available to any third parties. In addition, you shall not modify, translate into other languages, reverse engineer, decompile, disassemble or otherwise create derivative works from the App or any documentation concerning the App.
            </p>
            <p>
              You shall not transfer, lend, rent, lease, distribute the App, or use it for providing services to a third party, or grant any rights to the App or any documentation concerning the App to a third party.
            </p>
            <p>
              Misuse of any trademarks or any other content displayed on the App is prohibited.
            </p>
            <p>
              You shall not copy and/or duplicate and/or distribute and/or publish and/or use any content in the App, directly or indirectly, by way of a violation of our Intellectual Property Rights.
            </p>
            <p>
              Moreover, you shall not make any attempts to use the App or part thereof for malicious intentions.
            </p>
            <p>
              Also we are not responsible for the way you use the App.
            </p>
            <p>
              It is clarified that we may adopt, against a user who violated the present Agreement, any legal measures at our disposal pursuant to the applicable laws.
            </p>
            <p>
              All disputes arising from the usage of the App, shall be governed by and construed in accordance with the laws of the United States of America, and shall be submitted to the sole jurisdiction of the competent courts of New York, New York, the United States of America.
            </p>
          </section>

          <section class="section">
            <h2>VIII. AVAILABILITY OF THE APP, SECURITY AND ACCURACY</h2>
            <p>
              In order to use the App, you are required to have a compatible mobile phone or tablet, and internet access. However, please note that we offer you widgets that save translations and allow you to access them later in offline mode.
            </p>
            <p>
              The App is available for downloading and installing on handheld compatible mobile devices running Apple iOS Operating System 11.0 with minimum system requirements.
            </p>
            <p>
              We do not warrant that the App will be compatible with all hardware and software which you may use.
            </p>
            <p>
              We make no warranty that your access to the App will be uninterrupted, timely or error-free. Neither does Apple have an obligation whatsoever to furnish any maintenance and support services with respect to the App.
            </p>
            <p>
              You acknowledge the App is provided via the internet and mobile networks and so the quality and availability of the App may be affected by factors outside our reasonable control.
            </p>
            <p>
              The version of the App may be upgraded from time to time to add support for new functions and services.
            </p>
            <p>
              We may change or update the App and anything described in it without noticing you. If the need arises, we may suspend access to the App, or close it indefinitely.
            </p>
            <p>
              You also warrant that any information that you submit to us is true, accurate and complete, and you agree to keep it actual at all times.
            </p>
            <p>
              You can discontinue using our Services at any time by choosing the relevant option in your iTunes Account Settings. If you decide not to use the App for any reason you should uninstall the App.
            </p>
          </section>

          <section class="section">
            <h2>IX. CHARGES</h2>
            <p>
              The App is provided on free basis. Once you download the App, you'll have access to its basic features.
            </p>
            <p>
              Access to some services and/or additional features within the App requires paid subscriptions. The full list of Premium options and pricing is provided on the App's page. You will have an opportunity to try Premium options during the free trial period as provided on the signup screen. After the free trial period expires an auto-renewing subscription period will start on a regular basis. Please mind that you will be charged automatically unless you cancel your subscription 24 hours before the end of the free trial period. When you cancel your subscription you will still have access to basic functions of the App. Premium options are available during the whole free trial period.
            </p>
            <p>
              Subscription with a free trial period will automatically renew to a paid subscription. Any unused portion of a free trial period, if offered, will be forfeited when the user purchases a subscription, where applicable. We reserve the right to modify, terminate or otherwise amend our offered subscription plans at any time.
            </p>
            <p>
              Your subscription will be automatically renewed within 24 hours before the current subscription ends. Auto-renew option can be turned off in your iTunes Account Settings at least 24 hours before the end of the current period. Payment will be charged to iTunes Account at confirmation of purchase. No cancellation of the current subscription is allowed during active subscription period. Subscriptions are managed by you. Please note that removing the App from your device does not deactivate your subscription.
            </p>
            <p>
              Certain services within the App may be available as an In-App Purchase.
            </p>
            <p>
              You may be charged by your communications service provider for downloading and/or accessing the App on your mobile phone or tablet device, so you should check the terms of agreement with your operator. This may include data roaming charges if you do this outside your home territory. All these charges are solely your responsibility. If you do not pay the bills related to your mobile phone or tablet device, then we assume that you have the permission from the person that does it before incurring any of these charges.
            </p>
          </section>

          <section class="section">
            <h2>X. THIRD PARTY WEBSITES AND RESOURCES</h2>
            <p>
              The App may link you to other sites on the Internet and contracted third parties to provide you certain services. We have no control over and accept no responsibility for the content of any website or mobile application to which a link from the App exists (unless we are the provider of those linked websites or mobile applications). Such linked websites and mobile applications are provided "as is" for your convenience only with no warranty, express or implied, for the information provided within them.
            </p>
            <p>
              You acknowledge that you must comply with applicable third party terms of agreement when using the App. You are solely responsible for and bear all risks arising from your use of any third-party websites or resources.
            </p>
            <p>
              If you have any queries, concerns or complaints about such third party websites or mobile applications (including, but not limited to, queries, concerns or complaints relating to products, orders for products, faulty products and refunds) you must direct them to the operator of that third party website or mobile application.
            </p>
          </section>

          <section class="section">
            <h2>XI. DISCLAIMER OF WARRANTIES</h2>
            <div class="important-note">
              <p>
                <strong>YOU AGREE THAT YOUR USE OF THE APP AND ITS SERVICES SHALL BE AT YOUR SOLE RISK. THE SERVICES AND ALL THE MATERIALS, INFORMATION, SOFTWARE, CONTENT INTEGRATED IN THE APP ARE PROVIDED "AS IS" AND "AS AVAILABLE". WE DO NOT MAKE ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, WITH REGARD TO THE MERCHANTABILITY, TECHNICAL COMPATIBILITY OR FITNESS FOR A PARTICULAR PURPOSE OF ANY SERVICE, PRODUCTS OR MATERIAL PROVIDED PURSUANT TO THIS AGREEMENT. WE DO NOT WARRANT THAT THE FUNCTIONS CONTAINED ON OR THROUGH THE SERVICES WILL BE AVAILABLE, UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT THE SERVICES OR THE SERVERS THAT MAKE THE SERVICE AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. WE ARE NOT RESPONSIBLE FOR BREACHES OF INDIVIDUAL'S PRIVACY AS A RESULT OF YOUR MISUSE OF THE APP. YOU ARE SOLELY RESPONSIBLE FOR OBTAINING A PERSON'S CONSENT FOR TRACKING WITHIN THE APP AND GUARANTEE THAT SUCH CONSENT IS VOLUNTARY, EXPLICIT AND UNAMBIGUOUS.</strong>
              </p>
            </div>
            <p>
              We do not give you any guarantee for the proper functionality of the App, however, if you believe that our App has not met your expectations, you may notify Apple, and Apple may refund the purchase price for the App to you; and that, to the maximum extent permitted by applicable law, Apple will have no other warranty obligation whatsoever with respect to the App, and any other claims, losses, liabilities, damages, costs or expenses attributable to any failure to conform to any warranty.
            </p>
          </section>

          <section class="section">
            <h2>XII. LIMITATION OF LIABILITY</h2>
            <div class="important-note">
              <p>
                <strong>IN NO EVENT SHALL WE BE LIABLE FOR DAMAGES OF ANY TYPE, WHETHER DIRECT OR INDIRECT, ARISING OUT OF OR IN ANY WAY RELATED TO THE APP AND SERVICES PROVIDED BY THE APP. WE SHALL NOT BE LIABLE UNDER ANY CIRCUMSTANCES FOR ANY SPECIAL, CONSEQUENTIAL, INCIDENTAL, EXEMPLARY OR PUNITIVE DAMAGES, OR LOSS OF PROFIT OR REVENUES, EVEN IF WE HAVE BEEN SPECIFICALLY ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. WE SHALL NOT BE LIABLE UNDER ANY CIRCUMSTANCES FOR DAMAGES ARISING OUT OF OR IN ANY WAY RELATED TO PRODUCTS, SERVICES AND/OR INFORMATION OFFERED OR PROVIDED BY ANY THIRD-PARTIES AND ACCESSED THROUGH THE APP OR BY ANY OTHER MEANS. YOU ALSO SPECIFICALLY ACKNOWLEDGE THAT WE ARE NOT LIABLE FOR COSTS OR DAMAGES ARISING OUT OF PRIVATE OR GOVERNMENTAL LEGAL ACTIONS RELATED TO YOUR USE OF ANY OF THE APP AND ITS SERVICES IN ANY COUNTRY.</strong>
              </p>
            </div>
            <p>
              Apple is not responsible for addressing your claims relating to the App or your possession and/or use of the App, including, but not limited to: (i) product liability claims; (ii) any claim that the App fails to conform to any applicable legal or regulatory requirement; and (iii) claims arising under consumer protection, privacy, or similar legislation.
            </p>
          </section>

          <section class="section">
            <h2>XIII. LEGAL COMPLIANCE</h2>
            <p>
              You must represent and warrant that (i) you are not located in a country that is subject to a U.S. Government embargo, or that has been designated by the U.S. Government as a "terrorist supporting" country; and (ii) you are not listed on any U.S. Government list of prohibited or restricted parties.
            </p>
          </section>

          <section class="section">
            <h2>XIV. THIRD PARTY BENEFICIARY</h2>
            <p>
              You acknowledge and agree that Apple, and Apple's subsidiaries are the third party beneficiaries of the present end-user license agreement, and that upon your acceptance of the terms and conditions of the present Terms of Use and EULA, Apple will have the right (and will be deemed to have accepted the right) to enforce these Terms of Use and EULA as a third party beneficiary thereof.
            </p>
          </section>

          <section class="section">
            <h2>XV. GOVERNING LAW AND CLAIMS</h2>
            <p>
              This Agreement shall be governed by and construed in accordance with the laws of the State of New York, USA.
            </p>
            <p>
              We make no representations that the App is appropriate or available for use in other locations. Those who access or use the App from other jurisdictions do so at their own volition and are responsible for compliance with local law.
            </p>
            <p>
              If you choose to access or use the App from or in locations outside of the United States, you are responsible for:
            </p>
            <ul>
              <li>ensuring that what you are doing in that country is legal; and</li>
              <li>the consequences and compliance by you with all applicable laws, regulations, byelaws, codes of practice, licenses, registrations, permits and authorizations.</li>
            </ul>
            <p>
              Any claims shall be exclusively decided by courts of competent jurisdiction in New York, New York, USA, and that applicable Federal law shall govern, without regard to choice of law principles.
            </p>
            <p>
              If you ever wish to seek any relief from us, you agree to waive the ability to pursue class action.
            </p>
            <p>
              If any controversy, allegation, or claim (including any non-contractual claim) arises out of or relates to the App and the Services provided by the App or this Agreement, then you and we agree to send a written notice to each other providing a reasonable description of the dispute, along with a proposed resolution of it. The notice shall be sent based on the most recent contact information. For a period of sixty (60) days from the date of receipt of notice from the other party, you and us will engage in a dialogue in order to attempt to resolve the dispute, though nothing will require either you or us to resolve the dispute on terms which either you or us, in each of our sole discretion, are uncomfortable with.
            </p>
          </section>

          <section class="section">
            <h2>XVI. TERMINATION</h2>
            <p>
              We reserve the right to terminate this Agreement at any time at its sole discretion for any reason.
            </p>
            <p>
              Upon any termination (a) the rights and licenses granted to you herein shall terminate; (b) you must cease all use of the App.
            </p>
          </section>

          <section class="section">
            <h2>XVII. SEVERABILITY</h2>
            <p>
              If at any time any provision of this Agreement is or becomes illegal, invalid or unenforceable in any respect, that provision shall be read down to become legal, invalid or unenforceable or, if this is not possible, deleted. The other terms of this Agreement shall continue to apply with full force and effect.
            </p>
            <p>
              You shall not assign or transfer or purport to assign or transfer the contract between you and us to any other person.
            </p>
          </section>

          <section class="section contact">
            <h2>XVIII. CONTACT INFORMATION</h2>
            <p>
              We reserve the right to respond to user support requests. If you want to submit a support request or have any questions about this Agreement or the App, please contact us using our support form.
            </p>
            <p class="contact-info">
              <strong>Email:</strong> <a href="mailto:sl9283191@gmail.com" class="email-link">sl9283191@gmail.com</a>
            </p>
          </section>

          <section class="section copyright">
            <p>
              Copyright © 2026 Yikens Technology HK Limited. All rights reserved.
            </p>
          </section>
        </div>
      </div>
    </main>

    <footer class="footer">
      <div class="container">
        <div class="footer-bottom">
          <p>&copy; 2026 Forms Pro for Google Forms. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Terms'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.terms {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f8f9fc;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header */
.header {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  padding: 1rem 0;
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-img {
  height: 32px;
  width: auto;
  object-fit: contain;
}

.logo {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: 0;
  margin: 0;
}

.nav {
  display: flex;
  gap: 2rem;
}

.nav-link {
  color: #666;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.95rem;
  transition: color 0.3s;
  position: relative;
  padding-bottom: 2px;
  border-bottom: 2px solid transparent;
}

.nav-link:hover {
  color: #1a1a1a;
}

.nav-link.router-link-active {
  color: #4c51bf;
  border-bottom-color: #4c51bf;
}

/* Main Content */
.main {
  flex: 1;
  padding: 60px 0;
}

.content-wrapper {
  background: white;
  padding: 48px;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.06);
  max-width: 900px;
  margin: 0 auto;
}

.page-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 40px;
  text-align: center;
  letter-spacing: 0;
}

.section {
  margin-bottom: 40px;
}

.section.intro {
  background: linear-gradient(135deg, #f0f4ff 0%, #e9ecff 100%);
  padding: 28px;
  border-radius: 12px;
  border-left: 4px solid #4c51bf;
  margin-bottom: 48px;
  box-shadow: 0 2px 8px rgba(76, 81, 191, 0.1);
}

.section.intro p {
  margin-bottom: 12px;
}

.section.intro p:last-child {
  margin-bottom: 0;
}

.section h2 {
  font-size: 1.75rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e5e7eb;
  scroll-margin-top: 100px;
}

.section p {
  line-height: 1.8;
  color: #4b5563;
  margin-bottom: 16px;
  font-size: 1rem;
}

.section p:last-child {
  margin-bottom: 0;
}

.section ul,
.section ol {
  margin: 16px 0 16px 24px;
}

.section ul {
  list-style-type: disc;
}

.section ol {
  list-style-type: decimal;
}

.section li {
  line-height: 1.8;
  color: #4b5563;
  margin-bottom: 8px;
  padding-left: 8px;
}

.section strong {
  color: #1a1a1a;
  font-weight: 600;
}

.important-note {
  background: linear-gradient(135deg, #fff9e6 0%, #ffe9cc 100%);
  padding: 24px;
  border-radius: 12px;
  border-left: 4px solid #f59e0b;
  margin: 24px 0;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.1);
}

.important-note p {
  margin-bottom: 0;
}

.section.contact {
  background: linear-gradient(135deg, #f8f9fc 0%, #f0f4ff 100%);
  padding: 28px;
  border-radius: 12px;
  text-align: center;
  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.contact-info {
  font-size: 1.1rem;
  padding: 16px;
  background: white;
  border-radius: 8px;
  margin-top: 16px;
}

.email-link {
  color: #4c51bf;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s;
  border-bottom: 2px solid transparent;
}

.email-link:hover {
  color: #5b21b6;
  border-bottom-color: #5b21b6;
}

.section.copyright {
  text-align: center;
  padding: 20px;
  border-top: 2px solid #e5e7eb;
  margin-top: 48px;
  color: #666;
  font-size: 0.95rem;
  background: #f8f9fc;
  border-radius: 8px;
}

/* Footer */
.footer {
  background: #1a1a1a;
  color: #999;
  padding: 32px 0;
}

.footer-bottom {
  text-align: center;
  font-size: 0.9rem;
}

/* Responsive */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 1rem;
  }

  .nav {
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: center;
  }

  .content-wrapper {
    padding: 32px 24px;
  }

  .page-title {
    font-size: 2rem;
  }

  .section h2 {
    font-size: 1.5rem;
  }

  .logo {
    font-size: 1.25rem;
  }

  .logo-img {
    height: 28px;
  }

  .logo-container {
    gap: 8px;
  }
}
</style>
